import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star } from "lucide-react";
import { CATALOG, fmt } from "@/data/catalog";
import { mediaUrl } from "@/data/pdpMedia";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

const IMAGE_SLOT = { single: "pdp_gallery_1" };

export const StickyBuyBar = ({ sku = "single" }) => {
  const [show, setShow] = useState(false);
  const { addItem, setOpen } = useCart();
  const p = CATALOG[sku];
  const img = (IMAGE_SLOT[sku] && mediaUrl(IMAGE_SLOT[sku])) || p.image;

  useEffect(() => {
    const h = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-buy-bar"
          initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-[#F2E8E6] bg-[#FFFCFA]/95 backdrop-blur-xl"
        >
          <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-3 px-4 py-3 md:px-12">
            <div className="flex min-w-0 items-center gap-4">
              <img src={img} alt={p.name} className="hidden h-12 w-12 rounded-[2rem] border border-[#F2E8E6] object-cover sm:block" />
              <div className="min-w-0">
                <p className="truncate max-w-[42vw] font-display text-base leading-tight text-[#2C2B2C] sm:max-w-none sm:text-lg">{p.name}</p>
                <span className="flex items-center gap-1.5 text-xs text-[#8A7F86]">
                  <Star className="h-3 w-3 fill-[#FBC4A8] text-[#FBC4A8]" /> 4.9 · {fmt(p.price)} {p.compareAt > p.price && <span className="line-through opacity-60">{fmt(p.compareAt)}</span>}
                </span>
              </div>
            </div>
            <button onClick={() => { addItem(sku, 1); toast.success("Added to your bag"); setOpen(true); }}
              data-testid="sticky-add-to-cart"
              className="group flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-[#FBC4A8] px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.14em] text-[#232222] transition-all hover:bg-[#F6B393] md:px-8 md:tracking-[0.18em] md:hover:tracking-[0.22em]">
              Add to Bag
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
